import { LatLngBounds } from 'leaflet';
import { SpeciesV2 } from '../interfaces';

const BASE_URL = 'https://api.gbif.org/';

export const getGBIFSpeciesObservation = async (
  bounds: LatLngBounds,
  language: string,
): Promise<[SpeciesV2[], string | null]> => {
  const sw = bounds.getSouthWest();
  const nw = bounds.getNorthWest();
  const ne = bounds.getNorthEast();
  const se = bounds.getSouthEast();

  const geometry = `POLYGON ((${sw.lng} ${sw.lat}, ${nw.lng} ${nw.lat}, ${ne.lng} ${ne.lat}, ${se.lng} ${se.lat}, ${sw.lng} ${sw.lat}))`;
  const url = `${BASE_URL}v1/occurrence/search?geometry=${encodeURIComponent(geometry)}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.status}`);
    }

    const data = await response.json();

    const speciesList: SpeciesV2[] = data.results.map((species: any) => ({
      id: species.key || species.gbifID || 0,
      name: species.scientificName,
      author: species.scientificNameAuthorship,
      family: species.family,
      commonNames: species.genericName || undefined,
      images: species.media?.map((item: any) => item.identifier) || [],
      taxaId: species.taxonKey?.toString(),
      taxaName: species.species,
      taxaRank: undefined,
      taxaRankLevel: undefined,
      category: species.taxonRank || undefined,
      is_invasive: undefined,
      is_endemic: undefined,
      is_eu_directive: undefined,
      is_grin_uses: undefined,
      iucn_red_list_category: species.iucnRedListCategory || undefined,
      native: species.establishmentMeans === 'NATIVE' ? 'true' : 'false',
      observed_data: species?.lastParsed ? new Date(species.lastParsed) : undefined,
      latitude: species?.decimalLatitude || undefined,
      longitude: species?.decimalLongitude || undefined,
    }));

    return [speciesList, null];
  } catch (error: any) {
    console.error('Error fetching GBIF species:', error);
    const errorMessage = error.message || 'An unexpected error occurred while fetching GBIF species.';
    return [[], errorMessage];
  }
};
